import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { useGetUgcSeasonAggregateLinksQuery } from '../../redux/apis/linkManagement/ugc/lMUgcSeasonApiSlice'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'

const UgcSeasonReviewing = React.memo(() => {
  const context = useContext(AppSettings)
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })
  const { data, isLoading,isFetching, error, refetch } =
    useGetUgcSeasonAggregateLinksQuery({
      page: pagination.current,
      page_size: pagination.pageSize
    })

  let columns = [
    {
      title: 'Campain ID',
      dataIndex: 'campaign_id',
      key: 'campaign_id',

    },
    {
      title: 'CAMPAIGN NAME',
      dataIndex: 'campaign_name',
      key: 'campaign_name',
      search: true
    },
    {
      title: 'CUSTOMERS',
      dataIndex: 'customers',
      key: 'customers',
      search: true,
      render: (customers, record) => <>{customers?.map(x => x)?.join(', ')}</>
    },

    {
      title: 'SCREENSHOTS COUNT',
      dataIndex: 'to_review_count',
      key: 'to_review_count',
      search: true
    },

    {
      title: 'Actions',
      dataIndex: 'campaign_id',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href={`/reviewing-screenshots/ugc-season/campaign/${record?.campaign_id}`}
            className='btn btn-outline-theme'
          >
            Review
          </a>
        </div>
      )
    }
  ]
  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }
  useEffect(() => {
    console.log(error)
    if (error) {
      toast.error(error)
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context]) // Add context as a dependency

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        refetch()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [refetch])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />

      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default UgcSeasonReviewing
